import script from "./DeleteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteButton.vue?vue&type=script&setup=true&lang=js"

import "./DeleteButton.vue?vue&type=style&index=0&id=7f594701&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f594701"]])

export default __exports__